import React from 'react';
import Avatar from '../../../shared/components/Avatar/Avatar';
import styles from './Message.module.css';

export default function Message({ message, isCurrentUser, isConsecutive }) {
  const time = new Date(message.ts).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });

  const cls = [
    styles.message,
    isCurrentUser ? styles.me : styles.other,
    isConsecutive ? styles.consecutive : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={cls}>
      <div className={styles.avatarCol}>
        {!isConsecutive && <Avatar name={message.name} avatarId={message.avatarId} size={30} />}
      </div>
      <div className={styles.body}>
        <div className={styles.meta}>
          {!isConsecutive && <span className={styles.sender}>{message.name}</span>}
          <span className={styles.time}>{time}</span>
        </div>
        <div className={styles.bubble}>{message.text}</div>
      </div>
    </div>
  );
}
